import axios from 'axios'
// 创建axios实例
const service = axios.create({
  baseURL: 'https://appshopify.sendfromchina.com/', // api 的 base_url  测试
  // baseURL: 'http://47.112.12.109:8443/user-service', // api 的 base_url 生产
  timeout: 5000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    let systemCode;
    //if (store.getters.token) {
      //systemCode = getSystemToken(store.getters.roles.userInfo.userId);
     // config.headers.Authorization = `Bearer ${getToken(store.getters.roles.userInfo.userId)}` // 让每个请求携带自定义token 请根据实际情况自行修改
    //}
    if (systemCode) {
      config.headers['systemCode'] = systemCode
    }
  
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)


// response 拦截器
// service.interceptors.response.use(
//   response => {
//     /**
//      * code为非'000000'是抛错
//      */
//     const res = response.data
//     if (res.code === '031705') {
//       return response.data
//     } else if (res.code !== '000000') {
//       Message({
//         message: res.message,
//         type: 'error',
//         duration: 5 * 1000
//       })

//       // 401:token过期或者校验不通过; 403:token校验成功,但是无权限访问;
//       if (res.code === 401 || res.code === 403 || res.code === '010003') {
//         MessageBox.confirm(
//           '你已被登出，可以取消继续留在该页面，或者重新登录',
//           '确定登出',
//           {
//             confirmButtonText: '重新登录',
//             cancelButtonText: '取消',
//             type: 'warning'
//           }
//         ).then(() => {
//           store.dispatch('FedLogOut').then(() => {
//             location.reload() // 为了重新实例化vue-router对象 避免bug
//           })
//         })
//       }
//       return Promise.reject('error')
//     } else {
//       return response.data
//     }
//   },
//   error => {
//     console.log('err' + error) // for debug
//     Message({
//       message: error.message,
//       type: 'error',
//       duration: 5 * 1000
//     })
//     return Promise.reject(error)
//   }
// )

export default service



// WEBPACK FOOTER //
// ./src/components/utils/requestf.js